import "./style.scss";

export function book_appointment_block() {
  const block = document.querySelector(".book_appointment_block");
  if (!block) return;
}
